<template>
  <AddFamilyTemplate
    :header="header"
    :internal="false"
  >
    <template #content>
      <AddFamilyConsent
        ref="consentForm"
        :internal="false"
      />
    </template>
    <template #actions>
      <v-layout
        align-center
        justify-end
        wrap
        :justify-center="$vuetify.breakpoint.xs"
      >
        <v-flex
          shrink
          :mr-4="$vuetify.breakpoint.smAndUp"
          order-xs2
          order-sm1
          :mt-2="$vuetify.breakpoint.xs"
        >
          <router-link
            :to="{ name: 'family-reporter-external' }"
            class="link_iconed"
          >
            <v-icon>chevron_left</v-icon>
            {{ $t('buttons.prev_button') }}
          </router-link>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            @click="nextStep()"
          >
            {{ $t('buttons.next_button') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AddFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
import AddFamilyConsent from '@/components/addFamily/AddFamilyConsent';
export default {
    name: 'FamilyConsent',
    components: { AddFamilyConsent, AddFamilyTemplate },
    computed: {
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('outside_family.header_subtitles.consent'),
                redirect: true
            };
        }
    },
    methods: {
        nextStep () {
            this.$refs.consentForm.submit();
        }
    }
};
</script>

<style scoped></style>
